import { render, staticRenderFns } from "./DetailsTab.vue?vue&type=template&id=504d2bf7&"
import script from "./DetailsTab.vue?vue&type=script&lang=js&"
export * from "./DetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports